import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"
import {TextModel} from "../../models/Text"
import {Sorting} from "../../models/Sorting"

export interface DesktopSortProps {
    sortOptions?: Sorting
    onSelect: (value: string) => void
    text: TextModel
    templating: {mainTemplate: string; fallbackTemplate: string}
}

export const DesktopSort = memo(({sortOptions, onSelect, text, templating}: DesktopSortProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName sortOptions={sortOptions} onSelect={onSelect} text={text} />
})
DesktopSort.displayName = "DesktopSort"

export default connect(DesktopSort)
